import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';

interface Props {
    show: boolean;
    onClose?: () => void;
    children: ReactNode;
}

function Modal(props: Readonly<Props>) {
    return (
        <ReactModal
            isOpen={props.show}
            onRequestClose={handleModalClose}
            portalClassName="modal-portal"
            overlayClassName="modal-overlay"
            className="modal-modal"
        >
            {props.children}
        </ReactModal>
    );

    function handleModalClose() {
        props.onClose?.();
    }
}

export default Modal;
